var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPartialCheckbox = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "#4F52C3",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 15,
  height: 15,
  rx: 2.5,
  fill: "inherit",
  stroke: "#4F52C3"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 7,
  width: 10,
  height: 2,
  rx: 1,
  fill: "#fff"
})));
export default SvgPartialCheckbox;